<script setup lang="ts">

const props = defineProps<{
    modelValue: string | number | null;
    options: Array<{ label: string; value: string | number }>;
    optionLabel?: string;
    optionValue?: string;
    disabled?: boolean;
}>();

const emit = defineEmits(['update:modelValue']);

const handleUpdate = (value: string | number | null) => {
    emit('update:modelValue', value);
};
</script>

<template>
    <VLSelectButton
        :model-value="props.modelValue"
        :options="props.options"
        :option-label="props.optionLabel"
        :option-value="props.optionValue"
        :disabled="props.disabled"
        @update:model-value="handleUpdate"
    />
</template>

<style scoped>
:deep(.p-togglebutton-checked .p-togglebutton-content) {
    background: var(--secondary-color);
    color: var(--white-color);
}
</style>
